import { Box, Button, Center, Text } from '@chakra-ui/react';
import { useState } from 'react';
import api from '../../api';
import { LangKey } from '../../intl';
import { TEST_DATA } from '../../root-constants';
import fb from '../../services/firebase.service';
import { useIntl } from '../../state/intl';
import useErrors from '../../utils/hooks/errors.hooks';
import useSnacks from '../../utils/hooks/snacks.hooks';
import Copyright from './Copyright';
import LoginForm from './LoginForm';

const LandingPage: React.FC = () => {
  const handleErr = useErrors();
  const { showError, showSuccess } = useSnacks();
  const { lang } = useIntl();

  const [loading, setLoading] = useState(false);

  async function handleSubmit(email: string, password: string) {
    setLoading(true);

    if (email === '' && password === '') {
      email = TEST_DATA.email;
      password = TEST_DATA.password;
    }

    try {
      await fb.auth().signInWithEmailAndPassword(email, password);
    } catch (err) {
      setLoading(false);
      showError(tx.error);
    }
  }

  async function handleResetPsw(email: string) {
    setLoading(true);

    try {
      await api.request('auth/resetPassword', { email });
      showSuccess();
    } catch (err) {
      handleErr(err);
    } finally {
      setLoading(false);
    }
  }

  const txs: {
    [key in LangKey]: {
      title: string;
      error: string;
      notHavePsw: string;
    };
  } = {
    en: {
      title: 'Sign in to your account',
      error: 'Unable to log in with this credentials',
      notHavePsw: 'I do not have a password yet',
    },
    it: {
      title: 'Entra con il tuo account',
      error: "Impossibile effettuare l'accesso con queste credenziali",
      notHavePsw: 'Non ho ancora una password',
    },
    es: {
      title: 'Sign in to your account',
      error: 'Unable to log in with this credentials',
      notHavePsw: 'I do not have a password yet',
    },
  };

  const tx = txs[lang];

  return (
    <Center flexDirection="column" w="100%" h="100%">
      <Center flexDirection="column">
        <Text mb="10px" fontWeight="700" fontSize={24}>
          {tx.title}
        </Text>

        <Text fontWeight="500">{'Kolumboos PMS'}</Text>

        <Box pt={5}>
          <LoginForm
            handleSubmit={handleSubmit}
            handleResetPsw={handleResetPsw}
            loading={loading}
          />
        </Box>
      </Center>

      <Button variant="link" mt={7} onClick={() => window.location.replace('/signup')}>
        {tx.notHavePsw}
      </Button>

      <Copyright />
    </Center>
  );
};

export default LandingPage;
